/* eslint-disable react/sort-comp */
/* eslint-disable no-case-declarations */
import React, {
  Component,
  useEffect,
  useState,
  useCallback,
  useReducer
} from 'react';
import {
  CustomModal,
  FIELD_CATEGORY,
  CUSTOM_FIELDS_TYPE,
  DEPENDENT_FIELD_MAP,
  DEFAULT_FIELDS_BY_COLUMN_NAME,
  getTranslatedText,
  useIntl
} from '@nile/components';
import {
  Button,
  Page,
  Heading,
  ButtonGroup,
  Modal
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { filter, forEach, isEmpty } from 'lodash';
import TicketClosure from './TicketClosure';
import DuplicateWarningModal from './DuplicateWarningModal';

class BulkClosureModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      updatedFields: {},
      ticketDetails: null,
      isSaveDisabled: true,
      ticketsToHighLight: [],
      enableDuplicate: false,
      dataToDuplicate: null,
      showWarning: false,
      unclosedTickets: null,
      filledFields: null,
      totalFields: null,
      allFormFields: {}
    };
    this.updateFields = this.updateFields.bind(this);
    this.saveAction = this.saveAction.bind(this);
    this.checkIsSaveDisabled = this.checkIsSaveDisabled.bind(this);
    this.onDuplicate = this.onDuplicate.bind(this);
    this.checkIsDuplicateDisabled = this.checkIsDuplicateDisabled.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    let fieldsToUpdate = {};
    this.props.bulkErrorsOnClosure.forEach((error) => {
      fieldsToUpdate = {
        ...fieldsToUpdate,
        [error?.param?.ticket?.ticketId]: error?.param?.fields
      };
    });

    let errorsOnClosure = {};
    this.props.bulkErrorsOnClosure.forEach((error) => {
      errorsOnClosure = {
        ...errorsOnClosure,
        [error?.param?.ticket?.ticketId]: error?.param?.fields
      };
    });

    const ticketDetails = this.props.bulkErrorsOnClosure.map((error) => {
      return {
        ticketId: error?.param?.ticket?.ticketId,
        displayId: error?.param?.ticket?.displayId,
        client: error?.param?.ticket?.client,
        site: error?.param?.ticket?.site,
        source: error?.param?.ticket?.source,
        subject: error?.param?.ticket?.subject
      };
    });

    const errorFields =
      this.props.bulkErrorsOnClosure &&
      this.props.bulkErrorsOnClosure.map((el) => el.param.fields);

    const allFieldsValue =
      errorFields && errorFields.map((el) => Object.values(el)).flat();

    const totalFields = allFieldsValue && allFieldsValue.length;
    const validationArray =
      allFieldsValue && allFieldsValue.flatMap((el) => !!el);
    const filledFields =
      validationArray && validationArray.filter((el) => el).length;

    this.setState({
      updatedFields: fieldsToUpdate,
      ticketDetails: ticketDetails,
      unclosedTickets: (ticketDetails && ticketDetails.length) || 0,
      totalFields: totalFields,
      filledFields: filledFields
    });
  }

  checkIsSaveDisabled() {
    const base = { ...this.state.updatedFields };
    const ObjectArray = Object.values(base);
    const valueArray = ObjectArray;

    const validationArray =
      valueArray && valueArray.flatMap((el) => Object.values(el)).flat();

    const enableSave =
      validationArray && validationArray.filter((el) => !el).length === 0;
    this.setState({ isSaveDisabled: !enableSave });
  }

  checkIsDuplicateDisabled() {
    const baseData = { ...this.state.updatedFields };

    const valueObject = Object.values(baseData)[0];

    if (valueObject) {
      const valueArray = Object.values(valueObject).flat();
      const disableDuplicate = valueArray.filter((el) => !el).length === 0;
      this.setState({
        enableDuplicate: disableDuplicate
      });
    }
  }

  componentDidUpdate() {
    this.checkIsDuplicateDisabled();
    this.checkIsSaveDisabled();
  }

  updateAllFields = (fields, ticketId) => {
    this.setState((prevState) => ({
      allFormFields: {
        ...prevState?.allFormFields,
        [ticketId]: fields
      }
    }));
  };

  saveAction() {
    let data = [];

    const ticketIds = Object.keys(this.state.updatedFields);

    ticketIds.forEach((ticketId) => {
      const currentTicket = this.props.bulkErrorsOnClosure.find(
        (errors) => errors?.param?.ticket?.ticketId === ticketId
      );

      const status = currentTicket?.param?.status
        ? {
            status: currentTicket?.param?.status
          }
        : {};
      const fields = this.state.updatedFields[ticketId];
      const keys = Object.keys(fields);
      const defaultFieldKeys = Object.values(DEFAULT_FIELDS_BY_COLUMN_NAME);
      let defaultFields = {};
      let customFields = {};

      keys.forEach((key) => {
        if (defaultFieldKeys.includes(key)) {
          defaultFields = { ...defaultFields, [key]: fields[key] };
        } else {
          customFields = { ...customFields, [key]: fields[key] };
        }
      });

      const fieldsForResponse = {
        ticketId: ticketId,
        ...defaultFields,
        ...status,
        customFields
      };

      data = [
        ...data,
        {
          ticketId: ticketId,
          fields: fields,
          customFields: customFields,
          defaultFields: defaultFields,
          fieldsForResponse: fieldsForResponse
        }
      ];
    });

    if (this.props.onSave) {
      this.props.onSave(data);
    }
  }

  isNotEmpty = (val) => {
    return val && val.length > 0;
  };

  onDuplicate() {
    const baseData = { ...this.state.updatedFields };
    let updatedData = { ...this.state.updatedFields };
    const ticketsToHighLight = [];
    const dataToDuplicate = Object.values(baseData)[0];
    this.setState({ dataToDuplicate: dataToDuplicate });
    Object.keys(this.state.updatedFields).forEach((ticketId, i) => {
      if (i > 0) {
        const valueArray = Object.values(baseData[ticketId]);
        const isEmpty = !valueArray.some(this.isNotEmpty);
        if (isEmpty) {
          updatedData = { ...updatedData, [ticketId]: dataToDuplicate };
        } else {
          ticketsToHighLight.push(ticketId);
          this.setState({
            ticketsToHighLight: ticketsToHighLight,
            showWarning: true
          });
        }
      }
    });

    this.setState({
      updatedFields: updatedData
    });
  }

  closeModal() {
    this.props.setModalActive(false);
    this.setState({
      updatedFields: {},
      ticketDetails: null,
      isSaveDisabled: true
    });
  }

  setFields = (field, value, updatedFormFields) => {
    const { fieldCategory, columnName, dependantName, fieldType } = field;
    const dataToUpdate = updatedFormFields;
    let updatedField = {};
    if (fieldCategory === FIELD_CATEGORY.DEFAULT) {
      if (dependantName) {
        updatedField = {
          ...dataToUpdate,
          [columnName]: value?.value,
          [dependantName]: null
        };
      } else {
        updatedField = {
          ...dataToUpdate,
          [columnName]: value?.value || null
        };
      }
    }

    if (fieldCategory === FIELD_CATEGORY.CUSTOM) {
      if (fieldType === CUSTOM_FIELDS_TYPE.SELECT) {
        updatedField = {
          ...dataToUpdate,
          [columnName]: value?.value || null
        };
      } else if (fieldType === CUSTOM_FIELDS_TYPE.MULTI_SELECT) {
        const val = value.map((el) => el?.value);
        updatedField = { ...dataToUpdate, [columnName]: val };
      } else if (fieldType === CUSTOM_FIELDS_TYPE.CHECKBOX) {
        let updatedValue = dataToUpdate[columnName];
        if (value?.value) {
          updatedValue = updatedValue
            ? [...updatedValue, value?.label]
            : [value?.label];
        } else {
          updatedValue = updatedValue.filter((el) => el !== value?.label);
        }
        updatedField = {
          ...dataToUpdate,
          [columnName]: updatedValue
        };
      } else if (fieldType === CUSTOM_FIELDS_TYPE.RADIO) {
        let updatedValue = dataToUpdate[columnName];
        if (value?.value) {
          updatedValue = value?.label;
        }
        updatedField = {
          ...dataToUpdate,
          [columnName]: updatedValue || null
        };
      } else {
        updatedField = {
          ...updatedField,
          [columnName]: value
        };
      }
    }
    return updatedField;
  };

  getChilds = (field, ticketId) => {
    const { allFormFields } = this.state;
    const result = [];
    function findChildren(parentColumnName) {
      if (!parentColumnName) return;
      const children = filter(
        allFormFields?.[ticketId],
        (field) => field?.parentField?.columnName === parentColumnName
      );
      result.push(...children);
      forEach(children, (child) => findChildren(child?.columnName));
    }
    findChildren(field?.columnName);
    return result;
  };

  updateFields(ticketId, field, value) {
    let updatedFormFields = this.state.updatedFields?.[ticketId];
    let fldValue = this.setFields(field, value, updatedFormFields);
    updatedFormFields = { ...updatedFormFields, ...fldValue };
    const childs = this.getChilds(field, ticketId);
    if (!isEmpty(childs)) {
      let flds = updatedFormFields;
      childs?.map((el) => {
        flds = this.setFields(el, null, flds);
        updatedFormFields = { ...updatedFormFields, ...flds };
      });
    }
    this.setState((prevState) => ({
      updatedFields: {
        ...prevState.updatedFields,
        [ticketId]: updatedFormFields
      }
    }));
    this.checkIsSaveDisabled();
    this.checkIsDuplicateDisabled();
  }

  toggleModal = () => {
    this.setState({ showWarning: !this.state.showWarning });
  };

  onDuplicateAll = () => {
    const baseData = { ...this.state.updatedFields };
    const { dataToDuplicate } = this.state;
    const ticketIds = Object.keys(baseData);
    let updatedData = {};
    ticketIds.forEach((ticketId) => {
      updatedData = { ...updatedData, [ticketId]: dataToDuplicate };
    });

    this.setState({
      updatedFields: updatedData,
      showWarning: false,
      ticketsToHighLight: []
    });
  };

  render() {
    const { modalActive } = this.props;

    const {
      unclosedTickets,
      filledFields,
      totalFields,
      allFormFields
    } = this.state;

    const intl = useIntl();

    const subtitle = getTranslatedText(
      intl,
      'tickets.bulkClosure.modal.subtitle',
      {
        ticketCount: unclosedTickets,
        filledFieldsCount: filledFields,
        totalFieldsCount: totalFields
      }
    );

    return (
      <>
        <Modal
          open={modalActive}
          onClose={this.closeModal}
          title=""
          showCloseButton={false}
          noScroll
          large
        >
          <Page
            variant="primary"
            contentHeight="140px"
            title={
              <Heading element="h1">
                <FormattedMessage id="ticket.closure.modal.title" />
              </Heading>
            }
            subtitle={subtitle}
            primaryAction={
              <>
                <ButtonGroup>
                  <Button plainSecondary onClick={this.closeModal}>
                    <FormattedMessage id="common.cancel" />
                  </Button>
                  <Button
                    primary
                    onClick={this.saveAction}
                    disabled={this.state.isSaveDisabled}
                    loading={this.props.loading}
                  >
                    <FormattedMessage id="common.save" />
                  </Button>
                </ButtonGroup>
              </>
            }
          >
            <div>
              <div className="content-wrapper">
                <div className="flex col g20">
                  {this.state.ticketDetails &&
                    this.state.ticketDetails.map((ticket, idx) => {
                      const fields = this.state.updatedFields?.[
                        ticket?.ticketId
                      ];
                      return (
                        <>
                          <TicketClosure
                            ticket={ticket}
                            updateFields={this.updateFields}
                            fields={fields || {}}
                            key={ticket?.ticketId}
                            showDuplicateButton={idx === 0}
                            onDuplicate={this.onDuplicate}
                            highlight={this.state.ticketsToHighLight.includes(
                              ticket?.ticketId
                            )}
                            updateAllFields={this.updateAllFields}
                            disableDuplicate={!this.state.enableDuplicate}
                          />
                        </>
                      );
                    })}
                </div>
              </div>
              {this.state.showWarning && (
                <>
                  <DuplicateWarningModal
                    modalActive={this.state.showWarning}
                    setModalActive={this.toggleModal}
                    totalTickets={this.state.ticketsToHighLight.length}
                    onDuplicateAll={this.onDuplicateAll}
                  />
                </>
              )}
            </div>
          </Page>
        </Modal>
      </>
    );
  }
}

export default BulkClosureModal;
